import { create } from 'zustand';
import { DEFAULT_PALETTE_ID } from '@wg/shared';

export type RenderMode = '2d' | '3d-smooth' | '3d-voxel';
export type AnimationMode = 'none' | 'rise' | 'ripple' | 'dissolve';
export type TwoDMode = 'raw' | 'biome' | 'contour' | 'shaded';

type ViewState = {
  renderMode: RenderMode;
  twoDMode: TwoDMode;
  paletteId: string;
  animationMode: AnimationMode;
  setRenderMode: (m: RenderMode) => void;
  setTwoDMode: (m: TwoDMode) => void;
  setPalette: (id: string) => void;
  setAnimation: (a: AnimationMode) => void;
  reset: () => void;
};

const DEFAULTS = {
  renderMode: '2d' as RenderMode,
  twoDMode: 'raw' as TwoDMode,
  paletteId: DEFAULT_PALETTE_ID,
  animationMode: 'rise' as AnimationMode,
};

export const useViewStore = create<ViewState>((set) => ({
  ...DEFAULTS,
  setRenderMode: (renderMode) => set({ renderMode }),
  setTwoDMode: (twoDMode) => set({ twoDMode }),
  setPalette: (paletteId) => set({ paletteId }),
  setAnimation: (animationMode) => set({ animationMode }),
  reset: () => set(DEFAULTS),
}));
